<template>
  <BaseInput
    v-bind="$attrs"
    @click="handleOpenMap"
  />
  <BaseMapView
    v-if="!$attrs.readonly"
    v-model:visible="isOpenMapView"
    @save="emit('update:modelValue', $event.address)"
  />
</template>

<script setup lang="ts">
import BaseInput from '../input/index.vue'
import BaseMapView from '../map-view/index.vue'

const emit = defineEmits<{
  (e: 'update:modelValue', value: string): void
}>()

const attrs = useAttrs()

const isOpenMapView = ref(false)

function handleOpenMap() {
  if (!attrs.readonly) {
    isOpenMapView.value = true
  }
}
</script>
